import FinancialCard from "./FinancialCard";

export default FinancialCard;
